module.exports = __webpack_public_path__ + "static/media/slider04.2363e8a0.jpg";